/// <amd-module name="VSSUI/Components/IdentityCard/GroupCard" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import * as Resources from "VSSUI/Resources.Persona";
import { Tooltip } from "VSSUI/TooltipEx";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { CardContactLine } from "./CardContactLine";
import { IGroupCardProps } from "./ContactCard.Props";

export const GroupCard: React.FunctionComponent<IGroupCardProps> = (props: IGroupCardProps) => {
    const { identity, members, showOrganizationCard } = props;
    const { displayName, mail, physicalDeliveryOfficeName, telephoneNumber } = identity;
    const hiddenFocusElement = React.useRef<HTMLDivElement>(null);
    const renderContactInformation = mail || telephoneNumber || physicalDeliveryOfficeName;

    // onMount
    React.useEffect(() => {
        if (!renderContactInformation) {
            hiddenFocusElement.current && hiddenFocusElement.current.focus();
        }
    }, []);

    const memberButtonText = format(Resources.IdentityCardMembersCount, members ? members.length : 0);
    return (
        <div className="bolt-identity-default-card-without-header bolt-identity-card-content">
            <div ref={hiddenFocusElement} tabIndex={-1} />
            <div className="flex-row">
                <Persona className="bolt-identity-card-persona-main" size={PersonaSize.size72} identity={identity} />
                <div className="flex-column flex-grow bolt-identity-card-name scroll-hidden">
                    <Tooltip text={displayName} overflowOnly={true}>
                        <div className="word-wrap title-s">{displayName}</div>
                    </Tooltip>
                    {members && members.length > 0 ? (
                        <div className="word-wrap">{format(Resources.IdentityCardMembers, members.length)}</div>
                    ) : (
                        undefined
                    )}
                </div>
            </div>

            <div>
                {/* Brief contact information */}
                {renderContactInformation && (
                    <div className="bolt-identity-default-card-info-wrapper">
                        <hr className="bolt-identity-card-hr" />
                        <div className="bolt-identity-default-card-contact-info-container">
                            {mail && <CardContactLine iconName="Mail" content={mail} link={`mailto:${mail}`} />}
                        </div>
                    </div>
                )}
                {members && members.length > 0 ? (
                    <div className="bolt-identity-default-card-member-list-wrapper ">
                        <hr className="bolt-identity-card-hr" />

                        <div className="bolt-identity-default-card-header-wrapper">
                            <Button
                                aria-label={memberButtonText}
                                className="bolt-identity-default-card-header pointer bolt-profile-card-tab-element flex-center"
                                onClick={() => {
                                    showOrganizationCard && showOrganizationCard();
                                }}
                                role="button"
                                text={memberButtonText}
                                subtle={true}
                            >
                                <Icon iconName={"ChevronRight"} />
                            </Button>
                        </div>
                    </div>
                ) : (
                    undefined
                )}
            </div>
        </div>
    );
};
